// A (?) beside a control, its explanation on hover or focus.
import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import HoverTooltip from "../HoverTooltip.jsx";

export default function HelpTip({ label, text, placement = "top" }) {
    return (
        <HoverTooltip label={text} placement={placement} wide maxWidth={280}>
            <button
                type="button"
                aria-label={label}
                className="inline-grid h-[18px] w-[18px] cursor-help place-items-center rounded-full border-0 bg-transparent p-0 text-[color:var(--muted-soft)] hover:text-[color:var(--ink)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[color:var(--green)]"
            >
                <QuestionMarkCircleIcon aria-hidden="true" className="h-[15px] w-[15px]" />
            </button>
        </HoverTooltip>
    );
}
